export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        $('#menu-main-menu').find('.dropdown').each(function() {
            $(this).children('a').each(function() {
                var url = $(this).attr('href');
                if (url !== '#') {
                    $(this).attr('data-url', url);
                    // $(this).attr('href','#');
                }
            });
        });




        $('#themeNav li.dropdown .nav-link').click(function(e) {
            if ($(window).width() >= 768 && $(window).width() < 1199) {
                var grandparent = $(this).next();
                if ($(this).hasClass('open1') && grandparent.hasClass('opened')) {
                    document.location.href = this.href;
                } else {
                    $(this).addClass('open1');
                    $('#menu-main-menu').find("i").removeClass('opened');
                    $(this).next(".dropdown-toggle1").click();
                }
            } else {
                location.href = this.href;
            }
            e.preventDefault();
        });
        $('#themeNav li.dropdown .dropdown-item').click(function(e) {
             if ($(window).width() >= 768 && $(window).width() < 1199) {
                var grandparent = $(this).next();
                if ($(this).hasClass('open1') && grandparent.hasClass('opened')) {
                    document.location.href = this.href;
                } else {
                    $(this).addClass('open1');
                    $('#menu-main-menu').find("i").removeClass('opened');
                    $(this).next(".dropdown-toggle1").click();
                }
            } else {
                location.href = this.href;
            }
            e.preventDefault();
        });

        $("li.dropdown > .dropdown-toggle1").on("click", function(e) {
            var current = $(this).next();
            var current1 = $(this);
            var grandparent = $(this).parent().parent();
            grandparent.find(".dropdown-menu:visible").not(current).removeClass('show1');
            grandparent.find(".dropdown-toggle1").not(current1).removeClass('opened');
            grandparent.addClass('open1111');
            $(this).toggleClass('opened');
            current.toggleClass('show1');
            e.stopPropagation();
        });
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            if (scroll >= 100) {
                $(".sticky-site-header").addClass("shadow_css");
            } else {
                $(".sticky-site-header").removeClass("shadow_css");
            }
        });
        window.onscroll = function() {
            myFunction()
        };
        var header = document.getElementById("sticky-header");
        var sticky = header.offsetTop;

        function myFunction() {
            if (window.pageYOffset > sticky) {
                header.classList.add("sticky");
            } else {
                header.classList.remove("sticky");
            }
        }

    },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js